import ErrorHandler from '@schachermayer/sch-vuejs-commons/src/errors';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { NotificationCenterApi } from '../../../build/swagger-code-extranet-api-definition';
import { NotificationsSummary } from '../../../build/swagger-code-extranet-api-definition/models';

const notificationCenterApi: NotificationCenterApi = new NotificationCenterApi({ basePath: process.env.VUE_APP_CONTEXT_BASE });

@Module({
    namespaced: true,
    name: 'notificationCenter',
})
export default class NotificationCenterStoreModule extends VuexModule {
    private static toLocale(userLanguage: string, userCountry: string): string {
        return userCountry ? `${ userLanguage }-${ userCountry }` : userLanguage;
    }

    notificationsSummary: NotificationsSummary = {
        totalCount: 0,
        notifications: [],
    };

    @Mutation
    setNotificationsSummary(notificationsSummary: NotificationsSummary) {
        this.notificationsSummary = notificationsSummary;
    }

    @Action({ rawError: true })
    async loadNotificationsSummary({ userLanguage, userCountry }) {
        try {
            const userLocale = NotificationCenterStoreModule.toLocale(userLanguage, userCountry);

            const notificationsSummary: NotificationsSummary = (await notificationCenterApi.getNotificationsSummary(
                userLocale,
                { credentials: 'same-origin' })).data;

            this.context.commit('setNotificationsSummary', notificationsSummary);
        } catch (error) {
            ErrorHandler.handleError(error);
            return [];
        }
    }
}
